const url = {
  //人员实名制
  realname: {
    // 预警告警
    warning: {
      alarmAll: "/alarm/screen/all",
      alarmRead: "/alarm/read",
    },
    //班组管理
    team: {
      check: "/team/list",
      info: "/team/get/",
      del: "/team/delete/",
      add: "/team/save",
      update: "/team/update",
    },
    //参建单位
    parameter: {
      check: "/enterprise/list",
      info: "/enterprise/get/",
      add: "/enterprise/save",
      update: "/enterprise/update",
    },
    //人员管理
    staff: {
      check: "/screen/staff/vocation",//工种分析
      train: "/screen/train",//安全教育分析
      record: "/screen/staff/record",//实时进出场人员
      doorVideo: "/screen/staff/door/video",//闸机视频列表
      datanum: "/screen/staff/data",//当日在岗人数
      graphHour: '/screen/staff/graph/hour'//在岗人数分析
    },
    //进出场
    field: {
      check: "/personEntryRecord/getByConditions",
      del: "/personEntryRecord/delete/",
    },
    //考勤
    attendance: {
      check: "/attendance/list",
      add: "/attendance/save",
      update: "/attendance/update",
      del: "/attendance/delete/",
    },
    //工程信息
    projectgong: {
      check: '/project/6',
      list: '/staff/list'
    },
    screen: {
      check: '/screen/env/data',
      list: '/meteorological/average',
      weather: '/screen/env/weather',
      alarmOverall:'alarm/overall'
    },
    //视频
    video: {
      chack: '/camera/role/17',
    }
  },
  //权限
  permissions: {
    check: '/getInfo',
    profile: '/system/user/getUser',
    generality: '/generality/change',//切换主体
    logout: '/logout'
  },

  //监控
  video: {
    cameraList: '/camera/list',
    bookmark: '/bookmark/get/6',
    bookmarkadd: '/bookmark/add',
    bookmarkdel: '/bookmark/'
  },
};
export default url;
